import { db } from '../config';

/**
 * Log a completed migration
 * @param {string} migrationName - Name of the migration
 * @param {Object} details - Additional migration details
 */
export const logMigration = async (migrationName, details = {}) => {
  const timestamp = new Date();
  
  await db.collection('migrations').doc(migrationName).set({
    completedAt: timestamp,
    ...details
  });

  console.log(`Migration "${migrationName}" logged at ${timestamp}`);
};

/**
 * Check if a migration has been run
 * @param {string} migrationName - Name of the migration to check
 */
export const checkMigration = async (migrationName) => {
  const doc = await db.collection('migrations').doc(migrationName).get();
  return doc.exists;
};
